export enum SignUpCheckInboxErrorCodes {
  INVALID_CODE,
}
